export const firstBreakpoint = 900;

export const secondBreakpoint = 600;

export const thirdBreakpoint = 400;

export const useSidebarBreakpoint = 850;
